import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import './assets/styles/main.css'
import App from './App.vue'
import {params} from "../params.js";

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')


const bgVideo = document.querySelector(".background-video");
if (bgVideo) {
    bgVideo.src = `/backgrounds/${params.backgroundSrc}`;
}